import { IconAlertCircle, IconExternalLink } from "@tabler/icons-react";

import { cn } from "@/lib/utils";

const ADS_MANAGER_BASE = "https://adsmanager.facebook.com/adsmanager/manage/campaigns";

/** Build Ads Manager URL; strip `act_` prefix when present for the `act` query param. */
export function buildMetaAdsManagerUrl(adAccountId?: string | null): string {
  const raw = adAccountId?.trim();
  if (!raw) return ADS_MANAGER_BASE;
  const numeric = raw.replace(/^act_/i, "");
  if (!numeric) return ADS_MANAGER_BASE;
  return `${ADS_MANAGER_BASE}?act=${encodeURIComponent(numeric)}`;
}

interface MetaLaunchPausedNoticeProps {
  /** Connected default Meta ad account id (`act_…` or numeric). */
  adAccountId?: string | null;
  className?: string;
}

/** What launching does and does not do, in the app's warning tone. */
export default function MetaLaunchPausedNotice({ adAccountId, className }: MetaLaunchPausedNoticeProps) {
  const href = buildMetaAdsManagerUrl(adAccountId);
  return (
    <div
      role="note"
      className={cn(
        "flex items-start gap-2 rounded-md border border-amber-500/40 bg-amber-500/5 px-3 py-2 text-[13px] text-foreground",
        className
      )}
    >
      <IconAlertCircle size={16} stroke={1.75} className="mt-0.5 shrink-0 text-amber-500" aria-hidden />
      <div className="min-w-0 space-y-1">
        <p>Launching creates the campaign, ad set and ad in Meta as paused. Nothing spends until you turn it on.</p>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-xs font-medium text-foreground underline-offset-4 hover:underline"
        >
          Open Ads Manager
          <IconExternalLink size={12} stroke={1.75} aria-hidden />
        </a>
      </div>
    </div>
  );
}
